import React from 'react';
import PropTypes from 'prop-types';

import IconListItem from 'Components/shared/IconListItem/IconListItem';

import styles from './IconList.module.scss';

const IconList = ({ children, items }) => (
	<ul className={styles.list}>
		{items.map((item) => (
			<IconListItem key={item?.label} {...item} />
		))}
		{children}
	</ul>
);

IconList.propTypes = {
	children: PropTypes.node,
	items: PropTypes.arrayOf(PropTypes.shape(IconListItem.propTypes)),
};

IconList.defaultProps = {
	children: null,
	items: [],
};

export default IconList;
